import React from 'react';
import styled from 'styled-components';
import { FaChevronDown } from 'react-icons/fa';
import { fadeInAndUp } from '../base/keyframes/fades';
import media from '../base/media';
import { Button } from '../base';

export const Wrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: flex-end;
	padding: 3.5rem;
	margin: 0 -2rem;
	background-color: #fff;
	box-shadow: 0 8px 37px 0 rgba(147,94,196,0.19);
	opacity: 0;
	animation: ${fadeInAndUp} 650ms ease 1000ms forwards;
	${media.desktopSmall`
		flex-wrap: nowrap;
	`}
`;

export const FilterWrapper = styled.div`
	position: relative;
	flex-grow: 1;
	padding-top: 0rem;
	padding-bottom: 4rem;
	padding-left: 2rem;
	padding-right: 2rem;
	width: 100%;
	${media.tablet`
		flex: 0 50%;
		&:nth-of-type(3) { padding-bottom: 0; }
	`}
	${media.desktopSmall`
		flex: 0 50%;
		padding-bottom: 0rem;
	`}

`;

export const FilterLabel = styled.div`
	position: absolute;
	top: -2.5rem;
	left: 2rem;
	font-size: 1.3rem;
`;

const StyledFilterInput = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 1.6rem;
	line-height: 2.6rem;
	padding: 1rem 0;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	font-weight: 700;
	color: ${({ theme }) => theme.colors.black};
	transition: border-color 150ms ease;
	cursor: pointer;

	&:hover {
		border-color: ${({ theme }) => theme.colors.borderDark};
	}
`;

export const FilterInput = ({ children }) => (
	<StyledFilterInput>
		{children}
		<FaChevronDown />
	</StyledFilterInput>
);

export const ButtonWrapper = styled.div`
	padding: 0 2rem;
	width: 100%;
	${media.tablet`
		width: 50%;
	`}
	${media.desktopSmall`
		width: auto;
	`}
`;

export const StyledButton = styled(Button)`
	width: 100%;
	${media.desktopSmall`
		width: auto;
	`}
`;
